// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "style." + "f574d2271fa81ccc581b" + ".css";
};